import { useEffect, useState } from 'react';
import { AlertData, clearAllAlerts, removeAlert, subscribe } from '../utils/showAlert';

/**
 * Displays all alerts in the top-right corner
 */
const AlertDisplay = () => {
    const [alerts, setAlerts] = useState<AlertData[]>([]);

    useEffect(() => {
        return subscribe(setAlerts);
    }, []);

    if (alerts.length === 0) {
        return null;
    }

    return (
            <div style={{
                position: 'fixed',
                top: '20px',
                right: '20px',
                zIndex: 9999,
                maxWidth: '500px',
                width: '100%'
            }}>
                {alerts.length > 1 && (
                        <div style={{ textAlign: 'right', marginBottom: '10px' }}>
                            <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => clearAllAlerts()}
                            >
                                Close all
                            </button>
                        </div>
                )}
                {alerts.map((alert) => (
                        <div key={alert.id} style={{ marginBottom: '10px' }}>
                            <div className={`alert ${alert.variant} alert-dismissible fade show`} role="alert">
                                <h4 className="alert-heading">
                                    {alert.heading}
                                    {alert.count > 1 && <span style={{ fontWeight: 'normal', fontSize: '0.85em' }}> ({alert.count} occurrences)</span>}
                                </h4>
                                <p style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>{alert.message}</p>
                                <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => removeAlert(alert.id)}
                                        aria-label="Close"
                                ></button>
                            </div>
                        </div>
                ))}
            </div>
    );
}

export default AlertDisplay;
